export default["__VITE_ASSET__B7JqoXJ2__","__VITE_ASSET__uJ1pIJMc__"];